import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Link from '../Link'
import useScrollPercent from '../../hooks/useScrollPercent'
import useBanner from '../../hooks/useBanner'

const PromoBanner: React.FC = () => {
  const { showBanner, bannerRef, bannerText, bannerCtaLink, bannerCtaText } =
    useBanner()
  const { classes, cx } = useStyles()

  useScrollPercent(bannerRef, 0.5, [classes.slideOff])

  if (!showBanner) {
    return null
  }

  return (
    // Mui doesn't support `ref` for the `<Box />` in v4
    <Box
      className={cx(classes.banner, classes.animateBanner)}
      // @ts-ignore
      ref={bannerRef}
    >
      <Link href={bannerCtaLink} className={classes.bannerText}>
        {bannerText}
      </Link>
      {bannerCtaText && (
        <Link href={bannerCtaLink} className={classes.cta}>
          {bannerCtaText}
        </Link>
      )}
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  banner: {
    height: '3.75rem',
    background: 'linear-gradient(to right, #fcddb6 0%, #fdedd8 100%)',
    zIndex: 1100,
    position: 'sticky',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1.25rem',
    padding: '0.625rem',

    [theme.breakpoints.down('md')]: {
      height: '5rem',
    },

    [theme.breakpoints.down('sm')]: {
      height: '7.5rem',
      flexDirection: 'column',
      fontSize: '0.9375em',
      gap: '0.5rem',
    },
  },
  animateBanner: {
    transition: '0.5s',
  },
  slideOff: {
    transform: 'translateY(-100%)',
    transition: '0.5s',
  },
  bannerText: {
    color: '#08153b',

    '&:hover': {
      color: '#08153b',
    },
  },
  cta: {
    background: '#08153b',
    fontWeight: 600,
    letterSpacing: '0.2px',
    textAlign: 'center',
    color: theme.colors.white[100],
    padding: '0.5rem 1.40625rem',
    borderRadius: '3px',

    '&:hover': {
      color: theme.colors.white[100],
      boxShadow: '0 5px 10px #aeaeae',
      background: '#1e2a4c',
    },
  },
}))

export default PromoBanner
